import React, {useEffect} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import appendScript from './importScript';
import Header from './common/header'
import Intro from "./components/Intro";
import Menu from "./components/Menu";
import Tabs from "./components/Tabs";
import Accordion from "./components/Accordion";
import Modal from "./components/Modal";
import './styles/App.css';
import './styles/_app.scss';

function App() {

    useEffect(() => {
        appendScript("menu.js");
    }, []);

    return (
        <>
            <Header/>
            <Router>
                <Switch>
                    <Route path="/intro" component={Intro}/>
                    <Route path="/menu" component={Menu} />
                    <Route path="/tabs" component={Tabs} />
                    <Route path="/accordion" component={Accordion} />
                    <Route path="/modal" component={Modal} />
                    <Route path="/" component={Intro} />
                </Switch>
            </Router>
        </>

    );
}

export default App;
